/**
 * AusPost shipping rate proxy. Returns the native AusPost shape — note the
 * singular `service` key for what is actually an array.
 */

import { apiGet } from './client'

export type AuspostService = {
  code: string
  name: string
  price: string
  max_extra_cover?: number
  options?: {
    option?: AuspostOption | AuspostOption[]
  }
}

export type AuspostOption = {
  code: string
  name: string
  suboptions?: {
    option?: AuspostOption | AuspostOption[]
  }
  max_extra_cover?: number
}

export type AuspostCalcResponse = {
  services: {
    /** Singular key for an array — that's how AusPost ships it. */
    service: AuspostService[]
  }
}

export async function auspostCalc(params: {
  from_postcode: string
  to_postcode: string
  length: string | number
  width: string | number
  height: string | number
  weight: string | number
}): Promise<AuspostCalcResponse> {
  return apiGet<AuspostCalcResponse>('/v1/auspost/calc', {
    from_postcode: params.from_postcode,
    to_postcode: params.to_postcode,
    length: params.length,
    width: params.width,
    height: params.height,
    weight: params.weight,
  })
}
